import React, { useEffect, useState } from "react";
import Header from "../../Components/Header";
import { FaSearch } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { tableEye } from "../../common/Assets/imgs";
import MaterialTable from "../../Components/Table/MaterialTable";
import { get } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

const BookingManagement = () => {
  const [search, setSearch] = useState("");
  const navigation = useNavigate();
  const [step, setStep] = useState(1);
  const [getData, setGetData] = useState([]);
  const [tabName, setTabName] = useState("Request");
  const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState(1);
    const [totalCount, setTotalCount] = useState(1);
    const pageSize = 10;

  const location = useLocation();
  console.log("tabName", tabName);
  const { type, datas, data } = location.state || {};

//   const getStatusLabel = (status) => {
//     if (status === "Trip started") return "Ongoing";
//     return status;
//   };

 


  const requestColumns = [
    {
      header: "S.No",
    //    accessorFn: (row, index) => index + 1,
     accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,  
    id: "serial_no",
    },
    {
      accessorKey: "trip_code",
      header: "Trip ID",
    },
    {
      accessorKey: "user_name",
      header: "User Name",
    },
    {
      accessorKey: "vehicle_type",
      header: "Vehicle Type",
    },
    {
      accessorKey: "vehicle_count",
      header: "Vehicle Count",
    },
    {
      accessorKey: "total_amount",
      header: "Total Amount",
    },
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() => {
            navigation("/booking-request", {
              state: {
                datas: row.original,
                type: "view",
                step: step,
                tabName: "Request",
              },
            });
            console.log("transport_id", row.original?.id);

            // localStorage.setItem('transport_id', row.original?.id);
          }}
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  const assignedColumns = [
    { 
        header: "S.No", 
        // accessorFn: (row, index) => index + 1, 
             accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
        id: "serial_no" },
    { accessorKey: "trip_code", header: "Trip ID" },
    {
      accessorKey: "trip_pickup",
      header: "Pickup",
      Cell: ({ row }) => {
        const text = row.original.trip_pickup || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "trip_drop",
      header: "Drop",
      Cell: ({ row }) => {
        const text = row.original.trip_drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    { accessorKey: "vehicle_count", header: "Vehicle Count" },
    // { accessorKey: "status", header: "Status" },
    
       {
  accessorKey: "status",
  header: "Status",
  Cell: ({ cell }) => {
    const status = cell.getValue();
    return (
      <span className={status === "Assigned" ? "text-success" : ""}>
        {status === "Assigned" ? "Assigned" : status}
      </span>
    );
  }
},
{
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() => {
            navigation("/booking-request", {
              state: {
                datas: row.original,
                type: "view",
                step: step,
                tabName: "Assigned",
              },
            });

            // localStorage.setItem('transport_id', row.original?.id);
          }}
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  const ongoingColumns = [
    { header: "S.No", 
        // accessorFn: (row, index) => index + 1, 
             accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
        id: "serial_no" },
    { accessorKey: "trip_code", header: "Trip ID" },
    {
      accessorKey: "trip_pickup",
      header: "Pickup",
      Cell: ({ row }) => {
        const text = row.original.trip_pickup || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "trip_drop",
      header: "Drop",
      Cell: ({ row }) => {
        const text = row.original.trip_drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    { accessorKey: "vehicle_count", header: "Vehicle Count" },
   {
  accessorKey: "status",
  header: "Status",
  Cell: ({ cell }) => {
    const status = cell.getValue();
    return (
      <span className={status === "Trip Started" ? "text-primary" : ""}>
        {status === "Trip Started" ? "Ongoing" : status}
      </span>
    );
  }
},
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() => {
            navigation("/booking-request", {
              state: {
                datas: row.original,
                type: "view",
                step: step,
                tabName: "Ongoing",
              },
            });
            console.log("transport_id", row.original?.id);

            // localStorage.setItem('transport_id', row.original?.id);
          }}
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  const completedColumns = [
    { header: "S.No",
        //  accessorFn: (row, index) => index + 1,
              accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
         id: "serial_no" },
    { accessorKey: "trip_code", header: "Trip ID" },
    {
      accessorKey: "trip_pickup",
      header: "Pickup",
      Cell: ({ row }) => {
        const text = row.original.trip_drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    {
      accessorKey: "trip_drop",
      header: "Drop",
      Cell: ({ row }) => {
        const text = row.original.trip_drop || "";
        return text.length > 20 ? text.substring(0, 20) + "..." : text;
      },
    },
    { accessorKey: "vehicle_count", header: "Vehicle Count" },
    // { accessorKey: "status", header: "Status" },
       {
  accessorKey: "status",
  header: "Status",
  Cell: ({ cell }) => {
    const status = cell.getValue();
    return (
      <span className={status === "Delivered" ? "text-success" : ""}>
        {status === "Delivered" ? "Completed" : status}
      </span>
    );
  }
},
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() => {
            navigation("/booking-request", {
              state: {
                datas: row.original,
                type: "view",
                step: step,
                tabName: "Completed",
              },
            });
            console.log("transport_id", row.original?.id);

            // localStorage.setItem('transport_id', row.original?.id);
          }}
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];
  const cancelledColumns = [
    { header: "S.No",
        //  accessorFn: (row, index) => index + 1,
              accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
         id: "serial_no" },
    { accessorKey: "trip_code", header: "Trip ID" },
    {
      accessorKey: "trip_pickup",
      header: "Pickup",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return value?.length > 20 ? value.substring(0, 20) + "..." : value;
      },
    },
    {
      accessorKey: "trip_drop",
      header: "Drop",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        return value?.length > 20 ? value.substring(0, 20) + "..." : value;
      },
    },
    { accessorKey: "vehicle_count", header: "Vehicle Count" },
    // { accessorKey: "status", header: "Status" },
           {
  accessorKey: "status",
  header: "Status",
  Cell: ({ cell }) => {
    const status = cell.getValue();
    return (
      <span className={status === "Cancelled" ? "text-danger" : ""}>
        {status === "Cancelled" ? "Cancelled" : status}
      </span>
    );
  }
},
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div
          onClick={() => {
            navigation("/booking-request", {
              state: {
                datas: row.original,
                type: "view",
                step: step,
                tabName: "Cancelled",
              },
            });
            console.log("transport_id", row.original?.id);

            // localStorage.setItem('transport_id', row.original?.id);
          }}
        >
          <img src={tableEye} alt="" className="tableeye" />
        </div>
      ),
    },
  ];

  let dynamicColumns = requestColumns;
  

  if (step === 2) {
    dynamicColumns = assignedColumns;
    //   dynamicData = assignedData;
  } else if (step === 3) {
    dynamicColumns = ongoingColumns;
    //   dynamicData = ongoingData;
  } else if (step === 4) {
    dynamicColumns = completedColumns;
    //   dynamicData = completedData;
  } else if (step === 5) {
    dynamicColumns = cancelledColumns;
    //   dynamicData = cancelledData;
  }

  const tabs = [
    { name: "Request" },
    { name: "Assigned" },
    { name: "Ongoing" },
    { name: "Completed" },
    { name: "Cancelled" },
  ];

  const handleTabClick = (tab, index) => {
    setStep(index + 1);
    setTabName(tab?.name);
     setPagination(1);
    //    navigation(tab.path, { state: { datas, type } });
  };

  const getList = async (src, page) => {
    let idd;
    idd = step;
    if (step === 4) {
      idd = 5;
    } else if (step === 5) {
      idd = 6;
    }

    try {
        setLoader(true);
      const res = await get(`${URLS.BOOKINGS_LIST}${idd}/?search=${src}&page=${page}`);
      console.log("res", res);
      if (res?.results?.status === "success") {
        setGetData(res?.results?.data);
         setTotalCount(res?.count);
        setLoader(false);
      }
    } catch (err) {
      console.log("err", err);
      setLoader(false);
    }
  };
  useEffect(() => {
    getList(search, pagination);
  }, [step, search, pagination]);

  return (
    <div>
      <Header title={"Booking Management"} />

      <div className="container-fluid main-container">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
          {/* LEFT TITLE */}
          <h3 className="m-0 fw-bold fs-5 text-black">Booking Management</h3>

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">
            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3">
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-none bg-transparent"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="ms-2 searchdote">|</div>
              <FaSearch color="#7A52AB" className="ms-1" />
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="tabs mb-0 ms-3 mt-4">
          {tabs.map((tab, index) => (
            <button
              key={index}
              onClick={() => handleTabClick(tab, index)}
              className={`tab-btn ${step === index + 1 ? "active" : ""}`}
              //            className={`tab-btn ${
              //   location.pathname === tab.path ? "active" : ""
              // }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <MaterialTable
          columns={dynamicColumns}
          // data={dynamicData || []}
          data={getData || []}
          loading={loader}
           rowCount={totalCount}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>
    </div>
  );
};

export default BookingManagement;
